<template>
  <div v-if="!cargando">
    <videoplay/>
    <div v-if="false">
      <v-btn
        class="ma-3"
        block
        color="#0D47A1"
        style="color: white"
        @click="test('get')"
      >
        <h2>PROBAR BD GET</h2>
      </v-btn>
      <v-btn
        class="ma-3"
        block
        color="#0D47A1"
        style="color: white"
        @click="test('post')"
      >
        <h2>PROBAR BD POST</h2>
      </v-btn>
    </div>
    <br />
    <v-container style="align-items: center; align-items: center">
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }">
        <h1
          style="line-height: 35px; font-weight: normal; text-align: center"
          :style="{ color: $ajustes.colorTexto2 }"
          v-html="$textoFormateado($ajustes.textoMotivacion)"
        ></h1>
      </div>
    </v-container>
    <div>
      <cursos
        class="pa-3 pt-10"
        :propCursos="datosCursos"
        :style="{ backgroundColor: backgroundConOpacidad(0.1) }"
      />
      <noticias
        class="pa-3 pt-10"
        :propNoticias="datosNoticias"
        :style="{ backgroundColor: backgroundConOpacidad(0.2) }"
      />
      <nosotros
        class="pa-3 pt-10"
        :propInstituto="datosInstituto"
        :style="{ backgroundColor: backgroundConOpacidad(0.1) }"
      />
       <bibliotecas
        class="pa-3 pt-10"
        :propBibliotecas="$datosBibliotecas"
        :style="{ backgroundColor: backgroundConOpacidad(0.3) }"
      />
      <contactos
        :style="{ backgroundColor: backgroundConOpacidad(0.1) }"
        class="pa-3 pt-10"
        :propInstituto="datosInstituto"
        :propLinks="datosAjustesLinks"
      />
    </div>
    <v-img
      v-if="false"
      class="absolute top"
      style="left: 10px"
      :src="this.$appInfo.icon"
      width="100"
    >
    </v-img>
  </div>
  <div
    v-else
    class="center"
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
    "
  >
    <v-btn loading text large>
      Cargando
      <template #loader>
        <v-progress-circular
          indeterminate
          size="50"
          width="6"
          color="primary"
        ></v-progress-circular>
      </template>
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import videoplay from "@/components/inicio/video";
import cursos from "@/components/inicio/cursos";
import noticias from "@/components/inicio/noticias";
import nosotros from "@/components/inicio/nosotros";
import bibliotecas from "@/components/inicio/bibliotecas";
import contactos from "@/components/inicio/contactos";

export default {
  components: {
    videoplay,
    cursos,
    noticias,
    nosotros,
    bibliotecas,
    contactos,
  },
  metaInfo() {
    return {
      title: "Inicio",
      titleTemplate: "%s | INSEG",
      meta: [
        {
          name: "description",
          content:
            "INSEG Ecuador: Formación técnica y profesional en Seguridad Global y Transporte, INSEG Ecuador. Vive una experiencia innovadora y fortalece tus conocimientos con nosotros.",
        },
      ],
    };
  },
  data() {
    return {
      axios,
      idPc: "",
      splash: true,
      cargando: true,
      dialogSelectMode: false,
      nextRoute: "",
      dialogChanges: false,
      datosCursos: [],
      datosNoticias: [],
      datosInstituto: {
        mision: "",
        vision: "",
        historia: "",
        accesibilidad: "",
        principios: "",
        valores: "",
        direccion: "",
        telefono: "",
        correo: "",
        horario_dias: "",
        horario_horas: "",
      },
      datosAjustesLinks: {
        linkFacebook: "",
        linkInstagram: "",
        linkYoutube: "",
        linkEmail: "",
        linkWhatsapp: "",
      },
    };
  },
  mounted() {
    this.buscarInformacion();
  },
  created() {},
  methods: {
    backgroundConOpacidad(alpha) {
      const hex = this.colorBase.replace("#", "");

      // Soporte para colores de 3 o 6 caracteres
      const fullHex =
        hex.length === 3
          ? hex
              .split("")
              .map((c) => c + c)
              .join("")
          : hex;

      const r = parseInt(fullHex.substring(0, 2), 16);
      const g = parseInt(fullHex.substring(2, 4), 16);
      const b = parseInt(fullHex.substring(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    async buscarInformacion() {
      this.cargando = true;
      await this.obtenerInicial();
      await this.obtenerAjustes();
      this.cargando = false;
    },
    async obtenerInicial() {
      return await axios
        .get("/obtener_inicial")
        .then((response) => {
          if (response.data) {
            (this.datosCursos = response.data.cursos),
              (this.datosNoticias = response.data.noticias),
              this.llenarDatosInstituto(response.data.instituto);
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerAjustes() {
      return await axios
        .get("/obtener_ajustes")
        .then((response) => {
          if (response.data) {
            this.datosAjustesLinks.linkFacebook =
              response.data.data.linkFacebook;
            this.datosAjustesLinks.linkInstagram =
              response.data.data.linkInstagram;
            this.datosAjustesLinks.linkYoutube = response.data.data.linkYoutube;
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerCursos() {
      return await axios
        .get("/obtener_cursos")
        .then((response) => {
          if (response.data) {
            this.datosCursos = response.data.data;
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerNoticias() {
      return await axios
        .get("/obtener_noticias")
        .then((response) => {
          if (response.data) {
            this.datosNoticias = response.data.data;
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerInstructores() {
      return await axios
        .get("/obtener_instructores")
        .then((response) => {
          if (response.data) {
            this.datosNoticias = response.data.data;
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    llenarDatosInstituto(aux) {
      this.datosInstituto.mision = aux.mision;
      this.datosInstituto.vision = aux.vision;
      this.datosInstituto.historia = aux.historia;
      this.datosInstituto.accesibilidad = aux.accesibilidad;
      this.datosInstituto.principios = aux.principios;
      this.datosInstituto.valores = aux.valores;
      this.datosInstituto.direccion = aux.direccion;
      this.datosInstituto.telefono = aux.telefono;
      this.$appInfo.celular = aux.telefono;
      this.datosInstituto.correo = aux.correo;
      this.datosInstituto.horario_dias = aux.horario_dias;
      this.datosInstituto.horario_horas = aux.horario_horas;
    },
    loadAd(ad) {
      this.showAd = ad;
    },
    validUserById() {
      if (this.$author.id != "") {
        this.$router.push({ name: "Online" });
      }
    },
    showDialogLoginOrRegister(aux) {
      this.dialog = aux;
    },
    goTo(aux) {
      if (this.user.length < 4) {
        return;
      }
      this.$author.id = this.user;
      this.$router.push({ name: aux });
    },
    contact() {
      window.open(this.url, "_blank");
    },
    close() {
      this.dialog.news = false;
    },
    endSplash() {
      this.splash = false;
      this.$emit("endSplash");
    },
  },
  computed: {
    colorBase() {
      // Asegura que haya un color por defecto si no se ha definido
      return this.$ajustes.colorCabecera || "#3498db";
    },
    user() {
      return this.$author.id;
    },
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // Asegurarse de limpiar el temporizador al destruir el componente
    }
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
